module.exports = __webpack_public_path__ + "fonts/CooperBlack.99ccb75b.eot";